// EXTERNAL
import React from "react";
import { Route, Switch } from "react-router-dom";
//ROUTES
import Lander from "./containers/Lander";
import Gallery from "./containers/Gallery";
import Manual from "./containers/Manual";
import Studio from "./containers/Studio";
//TEAMS
import LadBible from "./containers/studio/LadBible";
import DigitalTrends from "./containers/studio/DigitalTrends";
import Hello from "./containers/studio/Hello";

export default function Routes({ isDesktop }) {
  return (
    <Switch>
      <Route exact path="/gallery/post/:id">
        <Gallery isDesktop={isDesktop} />
      </Route>
      <Route exact path="/gallery/story/:id">
        <Gallery isDesktop={isDesktop} />
      </Route>

      {/* MANUAL BUILDS */}
      <Route exact path="/preview/:size/:id">
        <Manual isDesktop={isDesktop} />
      </Route>

      {/* CUSTOM SKINS */}
      <Route exact path="/v2/:format/6yta/:id">
        <LadBible isDesktop={isDesktop} />
      </Route>
      <Route exact path="/v2/:format/j5tj/:id">
        <DigitalTrends isDesktop={isDesktop} />
      </Route>
      <Route exact path="/v2/:format/1a8f/:id">
        <Hello isDesktop={isDesktop} />
      </Route>

      {/* STUDIO */}
      <Route exact path="/d/:size/:teamId/:id">
        <Studio isDesktop={isDesktop} />
      </Route>
      <Route exact path="/s/:size/:teamId/:id">
        <Studio isDesktop={isDesktop} />
      </Route>
      <Route exact path="/studio/:size/:teamId/:id">
        <Studio isDesktop={isDesktop} />
      </Route>
      {/* 09/12 - TO DELETE WHEN PROD UPDATED */}
      <Route exact path="/v2/:format/:teamId/:id">
        <Studio isDesktop={isDesktop} />
      </Route>
      {/* END OF DELETE */}
      <Route>
        <Lander isDesktop={isDesktop} />
      </Route>
    </Switch>
  );
}
